export default __webpack_public_path__ + "static/media/covid-test.efa6e78e.svg";